<div class="picto">
  <img class="picto-image" [src]="img" alt=""/>
  @if (pictoDesigns[pictoNumber]) {
    <div class="bg">
      @for (circle of pictoDesigns[pictoNumber].circles; track circle) {
        <div class="circle"
          [style.margin-left.rem]="circle.left" [style.margin-top.rem]="circle.top"
          [style.font-size.rem]="circle.size" [style.z-index]="circle.z" [style.background-color]="circle.color">
        </div>
      }
      @for (triangle of pictoDesigns[pictoNumber].triangles; track triangle) {
        <div class="triangle"
          [style.border-width]="triangle.height/2 +'rem '+ triangle.width +'rem '+ triangle.height/2 +'rem 0rem'"
          [style.margin-left.rem]="triangle.left" [style.margin-top.rem]="triangle.top"
          [style.transform]="'rotate(' + triangle.rotate + 'deg)'" [style.z-index]="triangle.z"
        [style.border-color]="triangle.color"></div>
      }
    </div>
  }
</div>